import type { InteractionsConfig } from '@wix/thunderbolt-becky-types'
export { TRIGGERS_AND_REACTIONS_NAME } from '@wix/thunderbolt-becky-root'

export const EMPTY_INTERACTIONS_CONFIG = { interactions: [], effects: {} } as InteractionsConfig
